import { HttpParams } from '@angular/common/http';
import { Filter, FilterModel } from '../models/common.model';
import { FilterType } from '../enums/common.enums';

export default class FiltersHelper {
  static getFilterParameters(filters: FilterModel | null, queryParams: HttpParams) {
    if (filters) {
      Object.keys(filters).forEach((key) => {
        const filterValue = filters[key as keyof FilterModel];
        if (this.isNotEmpty(filterValue)) {
          switch (key) {
            case 'courier':
            case 'courierId':
            case 'orderTypeId':
              queryParams = queryParams.set(`FilteredQuery.${this.capitalizeKey(key)}`, filters[key].join(','));
              break;
            case 'createdOn':
            case 'receivedOn':
            case 'deliveredOn':
            case 'startDate':
            case 'updatedDate':
            case 'pickupOn':
            case 'submittedOn':
              Object.keys(filterValue as Record<string, Date>).forEach((dateKey: string) => {
                const dateValue = (filterValue as Record<string, Date>)[dateKey];
                if (this.isNotEmpty(dateValue)) {
                  queryParams = queryParams.set(
                    `FilteredQuery.${this.capitalizeKey(dateKey)}`,
                    dateValue.toISOString(),
                  );
                }
              });
              break;
            default:
              queryParams = queryParams.set(`FilteredQuery.${this.capitalizeKey(key)}`, filterValue as string);
              break;
          }
        }
      });
    }

    return queryParams;
  }

  static isFilteredApplied(filters: FilterModel) {
    return Object.keys(filters).some((key) => this.isNotEmpty(filters[key as keyof FilterModel]));
  }

  static isNotEmpty(value: FilterModel[keyof FilterModel] | Date): boolean {
    if (value === null || value === undefined) return false;
    if (typeof value === 'string') return value.trim() !== '';
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === 'object')
      return Object.values(value as Record<string, any>).every((objectValue) => objectValue !== null);
    return false;
  }

  static capitalizeKey(key: string) {
    return key.charAt(0).toUpperCase() + key.slice(1);
  }

  static patchValues(filters: Map<string, Filter>, selectedFilters: FilterModel): Record<string, any> {
    const patch: Record<string, any> = {};
    filters.forEach((filter, key) => {
      if (filter.type === FilterType.MultiSelect) {
        const selectedIds = selectedFilters[key as keyof FilterModel] as any[] | undefined;
        if (!selectedIds?.length) {
          return;
        }
        const isBooleanArray = selectedIds.every((selectedId) => typeof selectedId === 'boolean');
        const matchedOptions = filter.options.filter(
          (option) =>
            selectedIds.includes(option.id) ||
            selectedIds.includes(option.value) ||
            (isBooleanArray && selectedIds.includes(option.id === 1)),
        );

        if (matchedOptions.length) {
          patch[key] = matchedOptions;
        }
      } else if (filter.type === FilterType.DateRange) {
        const dateRange = selectedFilters[key as keyof FilterModel] as Record<string, Date> | undefined;
        if (dateRange?.[`${key}Start`] || dateRange?.[`${key}End`]) {
          patch[key] = dateRange;
        }
      }
    });
    return patch;
  }
}
